import { TextStyle } from '@hh.ru/magritte-ui';

export const getTextStyle = (isVisited: boolean): TextStyle => (isVisited ? 'secondary' : 'primary');
